
  import { Vue, Component, Prop } from "vue-property-decorator";

  @Component
  export default class TagLabel extends Vue {
    @Prop({ type: String, required: true }) readonly labelText!: string;
  }
